"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uiReducer = void 0;
var _reduxActions = require("redux-actions");
var _immutable = require("immutable");
var _actions = require("./actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = (0, _immutable.Map)({
  ENABLE_MT_TWO_TRANSLATE: false,
  saveOfferToClaim: {},
  templateTour: {
    fetch: {}
  },
  isVisibleGlobalLoader: false
});
var uiReducer = exports.uiReducer = (0, _reduxActions.handleActions)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _actions.uiActions.setUiState, function (state, _ref) {
  var payload = _ref.payload;
  var path = payload.path,
    value = payload.value;
  var normalizePath = Array.isArray(path) ? path : String(path).split();
  return state.setIn(normalizePath, value);
}), _actions.setIsVisibleGlobalLoader, function (state, _ref2) {
  var visible = _ref2.payload;
  return state.set('isVisibleGlobalLoader', visible);
}), _actions.register, function (state, _ref3) {
  var ui = _ref3.payload;
  return state.merge((0, _immutable.Map)(ui));
}), _actions.update, function (state, _ref4) {
  var payload = _ref4.payload;
  var key = payload.key,
    ui = payload.ui;
  return state.mergeIn([key], ui);
}), _actions.unRegister, function (state, _ref5) {
  var key = _ref5.payload;
  return state.remove(key);
}), initialState, {
  prefix: 'tourscaner'
});